import * as AppConfig from "../../app/config/constants";
import axios from "axios";


class AuthApi {
    constructor(token) {
        this.auth_token = token
    }

    headers(additional_headers) {
        let headers = {}
        if (this.auth_token) {
            headers = {...headers, Authorization: this.auth_token}
        }
        return {
            ...headers,
            ...additional_headers
        }
    }

    async get(uri_suffix, params=null) {

        const uri = AppConfig.AUTH_API_BASE_URI + uri_suffix;

        const config = {
            headers: this.headers(),
            ...(params? {params: params} : {})
        }

        const res = await axios.get(
            uri,
            config
        )
        if (res.status !== 200) {
            throw new Error(`${res.status}: ${res.statusText}`)
        }
        return res.data
    }

    async post(uri_suffix, data, headers=null) {
        const uri = AppConfig.AUTH_API_BASE_URI + uri_suffix;
        const res = await axios.post(
            uri, data, {headers: this.headers(headers)}
        )
        //TODO: include redirects, 201 etc.
        if (res.status !== 200) {
            throw new Error(`${res.status}: ${res.statusText}`)
        }
        return res.data
    }

    async post_json(uri_suffix, data) {
        return await this.post(uri_suffix, data, {"Content-Type": "application/json"})
    }

    async post_form_encoded(uri_suffix, data) {
        return await this.post(uri_suffix, data)
    }

    async delete(uri_suffix) {
        const uri = AppConfig.AUTH_API_BASE_URI + uri_suffix;
        const res = await axios.delete(uri, {headers: this.headers()})
        if (res.status !== 200) {
            throw new Error(`${res.status}: ${res.statusText}`)
        }
    }

    async patch(uri_suffix, data, headers=null) {
        const uri = AppConfig.AUTH_API_BASE_URI + uri_suffix;
        const res = await axios.patch(
            uri, data, {headers: this.headers(headers)}
        )
        //TODO: include redirects, 201 etc.
        if (res.status !== 200) {
            throw new Error(`${res.status}: ${res.statusText}`)
        }
        return res.data
    }

    async patch_json(uri_suffix, data) {
        return await this.patch(uri_suffix, data, {"Content-Type": "application/json"})
    }


}

export default AuthApi
